import './App.css';
import "./index.css"
import React, { useEffect, useContext, useState } from 'react';
import { Route, Switch, useLocation, useParams } from "react-router-dom";
import Header from './commonComponents/Header';
import Home from './Pages/Home'
import Quran from "./Pages/Quran"
import Dua from "./Pages/Dua"
import PrayerAlert from "./Pages/PrayerAlert"
import QuranDetail from './commonComponents/QuranDetail';
import DuaDetail from "./commonComponents/DuaDetail";
import AllahNames from "./Pages/AllahNames";
import Backgrounds from "./commonComponents/Backgrounds";
import Conversations from './commonComponents/Conversations';
import IslamicStories from "./commonComponents/IslamicStories";
import IslamicStoriesDetails from "./commonComponents/IslamicStoriesDetails";
import Ramadan from "./commonComponents/Ramadan";
import Hajj from "./Pages/Hajj"
import RamdanList from "./commonComponents/RamdanList";
import { Context } from './context/Context'
import Loader from './commonComponents/Loader';
import Hades from './commonComponents/Hades';
import HadesList from './commonComponents/HadesList';
import SideMenu from "./commonComponents/SideMenu";
import LangModal from './commonComponents/LangModal';
import { commonText as text } from "./Database/Database";
import Modal from "./commonComponents/Modal";
import { reactLocalStorage } from 'reactjs-localstorage';
import { getHeaders, body, base, redirect_url, APP_VERSION } from "./Config";
import axios from 'axios';
import queryString from "query-string";
import Login from './Pages/Login';
import Otp from './Pages/Otp';
import Alfatiha from './Pages/Alfatiha';
import Videos from './Pages/Videos';
import Ramdan from './Pages/Ramdan';
import Audios from './Pages/Audios';
import Makkah from './Pages/Makkah';
import Sermon from './Pages/Sermon';
import { SendGuiDataEvents } from './lib/CommonScript';


function App() {

  const { showLoader, theme, showSideBar, showLangModal, handleLangModal, lang, showModal, verified, handleModal, isNewUser, handleVerifyUser, handleNewUser,handleShowLoader } = useContext(Context);
  console.log("show loader", showLoader)

  useEffect(() => {
    handleLangModal(false); // hide show lang modal
    document.title = text.title[lang];

  }, [])

  let location = useLocation();
  let params = queryString.parse(location.hash)
  console.log("params", params)
  console.log("params.uid", params["/?uid"])
  const uid = params["/?uid"]
  // const uid = Object.values(params).toString("")
  console.log("uid", uid)



  const checkSub = (uid) => {
    handleShowLoader(true)
    axios({
      method: 'post',
      url: base + "checkSub",
      data: JSON.stringify({ 'uid': uid }),
      headers: getHeaders()
    }
    ).then((resp) => {
      if (resp.data.status !== '' && resp.data.status != undefined) {
        if (resp.data.status === 'failed') {
          window.open(redirect_url,"_self")
          // const modalData = {
          //   title: text.modal.oops[lang],
          //   body: `${resp.data.message}`,
          //   btn: [text.modal.okay[lang]],
          //   apiName: "checksub"
          // }
          // handleModal(modalData, true)
          // handleVerifyUser(false)

        } else if (resp.data.status === 'success') {
          resp.data.currentStatus && localStorage.setItem("currentStatus", resp.data.currentStatus)
          resp.data.msisdn && localStorage.setItem("msisdn", resp.data.msisdn)

          // reactLocalStorage.set("subStatus", "inactive")
          if (resp.data.subStatus === 'new') {
            // handleNewUser(true)
            window.open(redirect_url, "_self")
          } else if (resp.data.subStatus === 'active') {
            handleVerifyUser(true)
            handleShowLoader(false)
          } else {

            window.open(redirect_url, "_self")

          //   const modalData = {
          //     title: text.modal.oops[lang],
          //     body: `${resp.data.message}`,
          //     btn: [text.modal.okay[lang]],
          //     api: "checksub"
          // }
          // console.log("failed modal from home.js")
          // handleModal(modalData, true);
          // handleVerifyUser(false)

          }
        }
      }
      reactLocalStorage.set("subStatus", resp.data.subStatus)
      // set loader false
    }).then((error) => {
      console.log("error -----> ", error)
    })
    .finally(() => {
      let guiDataEvents = {}
      guiDataEvents["event"] = "checksub"
      // guiDataEvents["status"] = loca lStorage.getItem("subStatus")
      guiDataEvents["currentstatus"] = localStorage.getItem("currentStatus")
      SendGuiDataEvents(guiDataEvents)
    })
  }


  useEffect(() => {
    if (uid !== '' && uid !== undefined) {
      reactLocalStorage.set("uid", uid);
      checkSub(uid)
    } else {
      if (reactLocalStorage.get("uid") !== '' && reactLocalStorage.get("uid") !== undefined) {
        checkSub(reactLocalStorage.get("uid"))
      } else {
        console.log("redirect ---> app.js")
        // window.open(redirect_url, "_self")
        handleNewUser(true)
      }
    }
  }, [])

 
useEffect(() => {
  const clearCacheOnVersionChange = () => {
    const currentVersion = APP_VERSION;
    const storedVersion = localStorage.getItem('app_version');
    const versionKey = `cache_cleared_v${currentVersion}`;
    
    // Check if version has changed or cache hasn't been cleared for this version
    if (storedVersion !== currentVersion || !localStorage.getItem(versionKey)) {
      console.log(`Version changed from ${storedVersion} to ${currentVersion} - clearing cache...`);
      
      // Clear localStorage
      localStorage.clear();
      
      // Clear sessionStorage
      sessionStorage.clear();
      
      // Clear browser cache
      if ('caches' in window) {
        caches.keys().then(cacheNames => {
          cacheNames.forEach(cacheName => {
            caches.delete(cacheName);
          });
          console.log('Browser cache cleared');
        });
      }
      
      
      // Set new version and cache cleared flag
      localStorage.setItem('app_version', currentVersion);
      localStorage.setItem(versionKey, 'true');
      
      console.log(`Cache cleared successfully for version ${currentVersion}`);
    } else {
      console.log(`Cache already cleared for version ${currentVersion}`);
    }
  };
  
  clearCacheOnVersionChange();
}, []);




  // useEffect(() => {

  //   if (!verified && reactLocalStorage.get("subStatus") == "inactive") {
  //     console.log("href change")
  //     const modalData = {
  //       title: text.modal.oops[lang],
  //       body: text.modal.pleaseSubscribe[lang],
  //       btn: [text.modal.okay[lang]]
  //     }
  //     handleModal(modalData, true);
  //   }
  // }, [])



console.log("verified boolean ----------> ",verified)
console.log("isNewUser boolean ----------> ",isNewUser)
  return (
    <div className="App overflow-y-auto px-2">
      <div className=''>
        {
          !isNewUser && showModal && <Modal />
        }
        {
          verified && showLangModal && window.location.pathname !== '/' && <LangModal />
        }
        {
         !isNewUser && verified && showSideBar &&
        //  <Anime
        //   easing="easeOutElastic"
        //   loop={false}
        //   duration={700}
        //   delay={200}
        //   translateX="2rem"
        //   //  scale={[0.75, 0.9]}
        //   >

         <SideMenu />
      //  </Anime>

        }
        {
          showLoader && <Loader />
        }
        {(verified || isNewUser) && window.location.pathname != '/login' &&  window.location.pathname != '/makkah' && window.location.pathname != '/otp' && <Header />}
        <Switch>
          {(verified || isNewUser) && <Route exact path="/" component={Home} />}
          {verified && <Route exact path="/2" component={Quran} />}
          {verified && <Route exact path="/4" component={PrayerAlert} />}
          {verified && <Route exact path="/quran_detail/:id" component={QuranDetail} />}
          {verified && <Route exact path="/dua_detail/:id" component={DuaDetail} />}
          {verified && <Route exact path="/3" component={Dua} />}
          {verified && <Route exact path="/5" component={AllahNames} />}
          {verified && <Route exact path="/6" component={Backgrounds} />}
          { verified && <Route exact path="/hadesList/:id" component={HadesList} />}

          {/* {verified && <Route exact path="/login" component={Login} />} */}
          {/* {verified && <Route exact path="/otp" component={Otp} />} */}
          {/* {verified && <Route exact path="/videos" component={Videos} />} */}
          {verified && <Route exact path="/1" component={Makkah} />}
          { verified && <Route exact path="/alFatiha" component={Alfatiha} />}
          { verified && <Route exact path="/allVideos" component={Videos} /> }
          { verified && <Route exact path="/9" component={Ramdan} />}
          { verified && <Route exact path="/8" component={Hajj} />}
          { verified && <Route exact path="/allAudios" component={Audios} />}
          { verified && <Route exact path="/7" component ={Hades} />}
          { verified && <Route exact path="/10" component={Sermon} />}

           {/* <Route exact path="/6" component={theme == "red" ? Hades : Conversations} /> */}
         {/* {  theme == "red" && <Route exact path="/hadesList/:id" component={  theme == "red" && HadesList} /> }
           <Route exact path="/7" component={IslamicStories} />
          <Route exact path="/islamicStoriesDetails/:id" component={IslamicStoriesDetails} />
          <Route exact path="/8" component={Ramadan} />
          <Route exact path="/ramdan_list/:id" component={RamdanList} />  */}

        </Switch>
      </div>
    </div>
  );
}

export default App;
